export default [
    {
        path: '/settings',
        name: 'settings',
        component: () => import('@/views/setting/SettingsView.vue'),
        meta: {
            requiresAuth: true,
        },
    },
];
